export const GET_REPORTE_LOGIN = 'GET_REPORTE_LOGIN';
export const GET_REPORTE_LOGIN_EXCEL = 'GET_REPORTE_LOGIN_EXCEL';
export const LOADING_REPORTE_LOGIN = 'LOADING_REPORTE_LOGIN';
export const LOADING_REPORTE_LOGIN_EXCEL = 'LOADING_REPORTE_LOGIN_EXCEL';